import React, { useContext, useEffect, useState } from 'react';

import JobDatasheetLanguageContext from 'src/components/JobDatasheet/context/JobDatasheetLanguageContext';
import { EiqCheckbox } from 'eiq-storybook';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';
import { prepareRuleAndGetExclusive } from './utils';

export const QuestionRadioButton = (props) => {
  const {
    isRectifiedQuestion,
    onChange,
    isSurvey = true,
    question: {
      radioButtonSettings: { rows, multipleAnswer },
      translations,
      validations,
      id
    },
    value,
    disableChange,
  } = props;

  const { selectedLanguage } = useContext(JobDatasheetLanguageContext);
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  let selectedResultValue = value ? value[selectedValueKey] : [];
  if(multipleAnswer && value && typeof value[selectedValueKey] === 'number'){
    selectedResultValue = [value[selectedValueKey]];
  }
  const [multiSelectValues, setMultiSelectValues] = useState(selectedResultValue);

  const [exclusive, setExclusive] = useState([]);
  useEffect(() => {
    setExclusive((validations || []).reduce((accu, { rule }) => [
      ...accu,
      ...prepareRuleAndGetExclusive(rule).exclusive,
    ], []));
  }, [validations]);
  let valueArray = Array.isArray(value?.value) ? value.value : [value?.value];
  if(isRectifiedQuestion) valueArray = Array.isArray(value?.rectifiedValue) ? value.rectifiedValue : [value?.rectifiedValue];
  const isExclusiveSelected = valueArray.some(c => exclusive.includes(c));

  useEffect(() => {
    if (!isSurvey) {
      selectedResultValue = value ? value[selectedValueKey] : [];
      if(multipleAnswer && value && typeof value[selectedValueKey] === 'number'){
        selectedResultValue = [value[selectedValueKey]];
      }
      setMultiSelectValues(selectedResultValue);
    }
  }, [value, isSurvey]);

  const getTranslatedOptions = () => {
    if (!selectedLanguage) {
      return rows.map(v => ({ value: v, label: v }));
    }

    const rowsTranslations = (translations || []).find(c => c.languageId === selectedLanguage)?.options;

    return (rowsTranslations || rows).map(v => ({ value: v, label: v }));
  };

  const getReturnObject = (event) => {
    const val = event.target.value;

    const returnObject = {
      ...value,
      type: 'radioButton',
    };

    returnObject[selectedValueKey] = getTranslatedOptions().findIndex(v => val === v.value);
    return returnObject;
  };

  const options = getTranslatedOptions();

  const getValue = () => {
    if (value) {
      const val = value[selectedValueKey];
      return options[val]?.value;
    }
    return null;
  };

  const getReturnObjectForMultiSelect = (selectedValue) => {
    let returnValue = selectedValue;
    if(isRectifiedQuestion && Array.isArray(returnValue) && !returnValue.length) {
      returnValue = null;
    }else if(Array.isArray(returnValue) && !returnValue.length) {
      return null;
    }
    
    const returnObject = {
      ...value,
      type: 'radioButton',
    };

    returnObject[selectedValueKey] = returnValue;

    return returnObject;
  };

  const onCheckboxChange = (event, index) => {
    let selectedValues = multiSelectValues || [] ;
    if(event.target.checked) {
      const isExclusiveIndex = exclusive.includes(index);
      const updatedMultiSelectValues = [...(isExclusiveIndex ? [] : selectedValues), index];
      const uniqueMultiSelectValues = [...new Set(updatedMultiSelectValues)];
      selectedValues = uniqueMultiSelectValues;
      setMultiSelectValues(uniqueMultiSelectValues);
    } else {
      const updatedMultiSelectValues = multiSelectValues.filter(val => val !== index);
      selectedValues = updatedMultiSelectValues;
      setMultiSelectValues(updatedMultiSelectValues);
    }
    const returnObject = getReturnObjectForMultiSelect(selectedValues);
    onChange(returnObject);
  };

  return (
    <s.QuestionRadioButtonWrapper>
      {multipleAnswer ? (
        options.map((option, index) => {
          const checked = (multiSelectValues || []).includes(index) ? 'checked' : false;

          return (
            <s.MultiRadioWrapperText key={index} >
              <s.MultiRadioOptionContainer>
                <EiqCheckbox 
                  checked={checked}
                  disabled={!checked && isExclusiveSelected}
                  onChange={!disableChange && ((e) => onCheckboxChange(e, index))}
                  type="checkbox"
                  value={multiSelectValues}
                  id={`checkbox-${id}-${selectedValueKey}-${index}`}
                  label={option?.label}
                />
              </s.MultiRadioOptionContainer>
            </s.MultiRadioWrapperText>
          )})) : (
          options.map((item, idx) => ( 
            <EiqCheckbox 
              key={`radio-${id}-${selectedValueKey}-${idx}`}
              onChange={(e) => onChange(getReturnObject(e))}
              checked={item.value === getValue() ? 'checked' : false}
              type="radio"
              value={item.value}
              id={`radio-${id}-${selectedValueKey}-${idx}`}
              label={item.label}
              spacer="radio-ui"
              name={`radio-${id}-${selectedValueKey}-${idx}`}
            />
          ))
      )}
    </s.QuestionRadioButtonWrapper>
  );
};
